import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Pagination from 'rsuite/Pagination';
import MyLoader from '../../common/loader.component';
import { OutletContextParams } from './delivery-orders-screen';
import { usePaginationQs } from '../../../utils/usePagination';
import { useSearchParamsPaginationEffect } from '../purchase-order/useSearchParamsPaginationEffect';
import { CleanConversation } from '../../../export-types/cleaned-types';
import { useConversationNewMessages } from '../../../api/conversation';
import { useTransportations } from '../../../api/transportations';
import { Row } from '../../row';

import { TransportationRowItem } from './transportation-tab-item';

export const TransportationsArchiveTab = () => {
  const { take, skip, handleSetPage, handleChangeLimit, page } =
    usePaginationQs(15);

  useSearchParamsPaginationEffect(handleSetPage);
  const { debouncedInternalId, linked, attention, selectSupplier, direction } =
    useOutletContext<OutletContextParams>();

  const { data, error, isLoading, mutate } = useTransportations({
    linked,
    attention,
    types: ['combined'],
    status: ['received'],
    take,
    skip,
    name: debouncedInternalId || undefined,
    supplierId: selectSupplier || undefined,
    direction,
    sort: 'receivedAt',
  });

  const newMessageHandler = React.useCallback(
    (updatedConversation: CleanConversation) => {
      if (
        data?.items.some((transportation) =>
          transportation.lines.some(
            (line) =>
              line.deliveryOrder.id === updatedConversation.deliveryOrder?.id,
          ),
        )
      ) {
        mutate();
      }
    },
    [data, mutate],
  );
  useConversationNewMessages(newMessageHandler, 'deliveries');

  if (isLoading) {
    return (
      <>
        <div className="pb-4">
          <MyLoader />
        </div>
      </>
    );
  }

  if (error || !data) {
    return (
      <>
        <div className="pb-4">Неизвестная ошибка</div>
      </>
    );
  }

  return (
    <>
      <div className="pb-4">
        {data.items.map((data) => (
          <Row>{() => <TransportationRowItem data={data} />}</Row>
        ))}
      </div>
      {data.total > take && (
        <div className="pb-4">
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="md"
            layout={['pager']}
            total={data?.total}
            limitOptions={[15, 20]}
            limit={take}
            activePage={page}
            onChangePage={handleSetPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
      )}
    </>
  );
};
